const adminUrl: string =
    import.meta.env.VITE_ADMIN_URL || import.meta.env.VITE_AUTH_URL;

export const ApiEnum = {
    DIGITAL_SALES: adminUrl + "/apiV2/digital-sales",
};
